import axios from "axios"

const controller = "/pedidoItems"

const PedidoItemsService = {
    paginar: async (request) => {
        const { data } = await axios.post(`${controller}/paginar`, request)
        return data
    },
    buscarRapido: async (request) => {
        const { data } = await axios.post(`${controller}/buscarRapido`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    eliminar: async (request) => {
        const { data } = await axios.post(`${controller}/eliminar`, request)
        return data
    },
    solicitarAprobacion: async (request) => {
        const { data } = await axios.post(`${controller}/solicitarAprobacion`, request)
        return data
    },
    aprobar: async (request) => {
        const { data } = await axios.post(`${controller}/aprobar`, request)
        return data
    },
    completar: async (request) => {
        const { data } = await axios.post(`${controller}/completar`, request)
        return data
    },
    buscarPedidoParaOC: async (request) => {
        const { data } = await axios.post(`${controller}/buscarPedidoParaOC`, request)
        return data
    },
    buscarProductosxPedido: async (request) => {
        const { data } = await axios.post(`${controller}/buscarProductosxPedido`, request)
        return data
    },
}

export default PedidoItemsService